<template>
    <el-dialog v-dialogDrag class="dialog" width="1080px" title="" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑人事信息
            </div>
        </div>

        <div class="dialog_body">
            <el-tabs style="padding: 0 20px" v-model="activeName">
                <el-tab-pane name="first">
                    <span slot="label"><i class="el-icon-date"></i> 人事信息 </span>
                    <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                             label-width="120px">
                        <el-form-item label="姓名">
                            <el-input style="width:200px" v-model="form.name" readonly placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="名族">
                            <el-input style="width:200px" v-model="form.family" placeholder="请输入名族"></el-input>
                        </el-form-item>
                        <el-form-item label="籍贯">
                            <el-input style="width:200px" v-model="form.native" placeholder="请输入籍贯"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="form.sex" placeholder="请选择性别" style="width: 202px">
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="出生日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.birthday"
                                            value-format="yyyy-MM-dd" style="width: 202px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input style="width:200px" v-model="form.tel" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                            <el-input style="width:200px" v-model="form.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌">
                            <el-input style="width:200px" v-model="form.political" placeholder="请输入政治面貌"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号" prop="idcard">
                            <el-input style="width:200px" v-model="form.idcard" placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                        <el-form-item label="学历">
                            <el-input style="width:200px" v-model="form.education" placeholder="请输入学历"></el-input>
                        </el-form-item>
                        <el-form-item label="专业">
                            <el-input style="width:200px" v-model="form.professional" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item label="毕业学校">
                            <el-input style="width:200px" v-model="form.school" placeholder="请输入毕业学校"></el-input>
                        </el-form-item>
                        <el-form-item label="住址">
                            <el-input style="width:200px" v-model="form.address" placeholder="请输入住址"></el-input>
                        </el-form-item>
                        <el-form-item label="入职日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.workdate"
                                            value-format="yyyy-MM-dd" style="width: 202px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="离职日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.leavedate"
                                            value-format="yyyy-MM-dd" style="width: 202px"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注" class="bzClass">
                            <el-input
                                    style="width: 865px"
                                    resize="none"
                                    type="textarea"
                                    placeholder="请输入备注"
                                    v-model="form.bz"
                            rows="2"
                                    show-word-limit>
                            </el-input>
                        </el-form-item>

                    </el-form>
                    <div style="text-align: center;padding: 10px 0px 20px 0px">
                        <el-button type="danger" @click="close">取 消</el-button>
                        <el-button type="primary" @click="submitForm">保 存</el-button>
                    </div>

                </el-tab-pane>
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  附件上传
                    </span>
                    <fileupload :formData="formData" @saveBtn="saveBtn" :paramData="paramData"></fileupload>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-dialog>
</template>

<script>
    import fileupload from '@/components/tools/fileupload'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {fileupload},
        data() {
            return {
                activeName: "first",
                dialoading: this.loading,
                form: {},
                paramData: {
                    table_name: "rs_user",
                    table_id: this.formData.id,
                },
                dialogVisible: true,
                formLabelWidth: '80px',
                rules: {
                    idcard: [
                        {required: true, message: '请输入身份证号', trigger: 'blur'},
                    ],
                }
            };
        },
        mounted() {
            this.getUserInfo();
        },
        methods: {
            close() {
                this.$emit('closeDialog')
            },
            async getUserInfo() {
                this.dialoading = true;
                let param = {
                    tablename: "rs_user_info",
                    key: "rs_user_id",
                    value: this.formData.id,
                }
                const data = await this.$sqlOpt.view.getDataByKey(param);
                if (data.code === '1') {
                    if (data.data === null) {
                        this.form = {
                            rs_user_id: this.formData.id,
                            name: this.formData.name,
                        }
                    } else {
                        this.form = data.data;
                        this.form.name = this.formData.name;
                    }
                }
                this.dialoading = false;
            },
            async submitForm() {
                this.$refs["formData"].validate(async (valid) => {
                    if (valid) {
                        this.dialogLoading = true;
                        let param = {
                            tablename: "rs_user_info",
                            ...this.form,
                        }
                        const data = await this.$sqlOpt.save.save(param);
                        this.dialogLoading = false;
                        if (data.code === '1') {
                            this.$emit('closeDialog')
                        }
                    } else {
                        this.$message({message: '数据未填完整', type: 'error'});
                    }
                });
            },
            saveBtn() {

            }
        }
    }
</script>

<style scoped>
    .dialog /deep/ .el-form-item__label {
        background-color: #c8ddf3;
        line-height: 38px;
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0.1);;
    }

    .dialog .bzClass /deep/ .el-form-item__label {
        line-height: 75px;
        height: 75px;
    }

    .dialog /deep/ .el-textarea__inner {
        background-color: #daecfa;
    }

    .dialog /deep/ .el-textarea .el-input__count {
        background-color: #daecfa;
    }

    .dialog /deep/ .el-form-item__content {
        line-height: 40px;
    }

    .dialog /deep/ .el-form-item {
        margin-bottom: 6px;
    }

    .dialog /deep/ .el-input__inner {
        background-color: #daecfa;
        height: 40px;
        line-height: 40px;
    }

    .dialog /deep/ .el-dialog__header {
        padding: 0;
        text-align: center;
    }

    .dialog /deep/ .el-dialog__headerbtn {
        top: 8px;
        right: 10px
    }

    .dialog /deep/ .el-dialog__headerbtn .el-dialog__close {
        color: #FFF;
    }


    .dialog /deep/ .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 0px;
    }

    .dialog /deep/ .el-tabs--border-card > .el-tabs__header {
        background-color: #FFF;
    }

    .dialog /deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        border-bottom-color: #DCDFE6;
    }

    .dialog .dialog_title {
        background-color: rgba(28, 136, 201, 0.6);
        padding: 5px 10px 5px;
    }

    .dialog .dialog_body {
        border-left: 10px solid rgba(28, 136, 201, 0.6);
        border-right: 10px solid rgba(28, 136, 201, 0.6);
        border-bottom: 10px solid rgba(28, 136, 201, 0.6);
        background-color: rgba(193, 245, 236, 0.15);
    }
</style>
